module.exports = __webpack_public_path__ + "media/images/pages/bg_area_05-a8b73c7bd768344ec26aab264b89e801.png";